import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Skeleton } from "@mui/material";

function TrackSectionMap() {
  const containerRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  /* ---------- Load map ONLY when in viewport ---------- */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" } // preload slightly before visible
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        width: "100%",
        height: { xs: 190, sm: 200, md: "100%" },
        minHeight: { md: 230 },
        position: "relative",
        overflow: "hidden",
        borderRadius: "20px",
        background: "#eeede2",
      }}
    >
      {/* ---------- Skeleton (NO CLS) ---------- */}
      {!iframeLoaded && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
        />
      )}

      {/* ---------- Load iframe only when needed ---------- */}
      {shouldLoad && (
        <iframe
          title="BBG Restaurant Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3533.6581515620232!2d85.33012167534864!3d27.666046327312127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb1905141b0983%3A0xbd5fda8d1783fc09!2sBBG%20Restaurant!5e0!3m2!1sen!2snp!4v1742030058531!5m2!1sen!2snp"
          width="100%"
          height="100%"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          style={{
            border: "none",
            position: "absolute",
            inset: 0,
          }}
          onLoad={() => setIframeLoaded(true)}
        />
      )}

      {iframeLoaded && (
        <Typography
          sx={{
            position: "absolute",
            top: 12,
            left: 12,
            zIndex: 2,
            px: 1.25,
            py: 0.6,
            borderRadius: "999px",
            background: "rgba(255,253,247,.92)",
            color: "#252920",
            fontSize: "0.72rem",
            fontWeight: 700,
            boxShadow: "0 4px 12px rgba(65,70,39,.14)",
          }}
        >
          BBG Food • Kathmandu
        </Typography>
      )}

      {/* ---------- Optional label ---------- */}
      {!iframeLoaded && shouldLoad && (
        <Typography
          sx={{
            position: "absolute",
            bottom: 8,
            left: 0,
            right: 0,
            textAlign: "center",
            fontSize: "0.8rem",
            color: "gray",
          }}
        >
          Loading map…
        </Typography>
      )}
    </Box>
  );
}

export default TrackSectionMap;
